import { Button, ButtonProps } from "react-aria-components";

interface TagElementProps {
  buttonProps?: ButtonProps;
  children: React.ReactNode;
  className: string;
  testID: string;
}

// used to swap between button and span for accessibility
export function TagElement(props: TagElementProps) {
  const { children, className, testID, buttonProps, ...rest } = props;
  if (buttonProps) {
    return (
      <Button
        style={{ cursor: "pointer" }}
        className={className}
        data-testid={testID}
        {...buttonProps}
        {...rest}
      >
        {children}
      </Button>
    );
  }

  return (
    <span className={className} data-testid={testID}>
      {children}
    </span>
  );
}
